import React from 'react';

import { Button } from '@mui/material';
import { formatDay } from "./helpers";

const AssignmentPill = ({ classUuid, assignment, date, onClick }) => {

    if (assignment) {
        const message = date ? formatDay(assignment.due_date) : assignment.progress + ' %';
        const complete = date ? date : assignment.progress === 100 && assignment.study_time >= assignment.expected_study_time;
        return (
            <Button
                variant="contained"
                size="small"
                disableElevation
                disabled
                sx={{
                    color: '#333333',
                    backgroundColor: complete ? '#93DC9A' : '#FFF7AC',
                    '&:hover': {
                        backgroundColor: complete ? '#93DC9A' : '#FFF7AC',
                    },
                    '&.Mui-disabled': {
                        color: '#333333',
                        backgroundColor: complete ? '#93DC9A' : '#FFF7AC',
                    },
                    fontWeight: 400,
                    fontSize: '100%',
                    padding: '3px 15px',
                }}
            >{message}</Button>
        );
    } else if (classUuid) {
        return (
            <Button
                variant="contained"
                size="small"
                disableElevation
                sx={{
                    color: '#333333',
                    backgroundColor: '#c2c2c2',
                    '&:hover': {
                        backgroundColor: '#a2a2a2',
                    },
                    fontWeight: 400,
                    fontSize: '100%',
                    padding: '3px 15px',
                }}
                onClick={onClick ? () => onClick(classUuid, null) : null}
            >+ create</Button>
        );
    } else {
        return null;
    }
}

export default AssignmentPill;
